/* import __COLOCATED_TEMPLATE__ from './tickets-screen.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();